module.exports = __webpack_public_path__ + "img/C7C7D7_4C4E5A_818393_6C6C74-256px.176aae89.png";